import type { Db } from "./types";

const tags = [
  { id: 0, name: "football-fan", color: "#dbe3ec" },
  { id: 1, name: "holiday-card", color: "#e7e2d8" },
  { id: 2, name: "influencer", color: "#e3dbe6" },
  { id: 3, name: "manager", color: "#d8e4dd" },
  { id: 4, name: "musician", color: "#e8ddd4" },
  { id: 5, name: "vip", color: "#dee6e9" },
];

export const generateTags = (_: Db) => {
  return [...tags];
};
